"use client";

import { motion } from "motion/react";
import type { ReactNode } from "react";
import { stepTransition, subPhaseVariants } from "../../_logic/constants";

interface SubPhasePanelProps {
  /** Unique key for this phase's screen — required by `AnimatePresence` for correct enter/exit
   *  matching. Pass the same value as the phase id. */
  phaseKey: string;
  direction: 1 | -1;
  className?: string;
  children: ReactNode;
}

/**
 * Shared sub-phase screen wrapper — the `motion.div key custom variants initial animate exit
 * transition` boilerplate copy-pasted per screen across every wizard step. Must render as a direct
 * child of the step's own `<AnimatePresence mode="wait" custom={direction}>` — `AnimatePresence`
 * needs its animated children directly, not through an intermediate component, so this only wraps
 * the per-screen `motion.div`, not the `AnimatePresence` itself.
 */
export function SubPhasePanel({ phaseKey, direction, className, children }: SubPhasePanelProps) {
  return (
    <motion.div
      key={phaseKey}
      custom={direction}
      variants={subPhaseVariants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={stepTransition}
      className={className}
    >
      {children}
    </motion.div>
  );
}
